/**
 * @deprecated please use @website/ui instead
 */
export enum SizeType {
  sm = "sm",
  md = "md",
  lg = "lg"
}
